<template>
    <span class="paginator-report">
        Exibindo <strong>{{ shown }}</strong> de <strong>{{ filtering ? pageTotal : total }}</strong>
        {{ filtering ? 'nesta página' : 'resultados' }}
    </span>
</template>
<script>
export default {
    name: 'TableResults',

    props: {
        // linhas visíveis agora (já com o filtro de busca aplicado)
        shown: {
            type: Number,
            default: 0
        },
        // total de registros no servidor (meta.total)
        total: {
            type: Number,
            default: 0
        },
        // registros carregados na página atual, base do filtro de busca
        pageTotal: {
            type: Number,
            default: 0
        },
        // busca ativa: o filtro só alcança a página carregada
        filtering: {
            type: Boolean,
            default: false
        }
    }
}
</script>
